import ADSProvider from "./context/ADSProvider";
import ADSHeader from "./Component/ADSHeader";
import ADSCredit from "./Component/ADSCredit";
import ADSContent from "./Component/ADSContent";
import AIToolsProvider from "./context/AIToolsProvider";
import ImageEditorProvider from "./context/ImageEditorProvider";
import "./ADS.scss";

// AI DESIGN STUDIO
const ADS = () => {
  return (
    <AIToolsProvider>
      <ADSProvider>
        <ImageEditorProvider>
          <div className="wrapper">
            {/* HEADER */}
            <ADSHeader />

            {/* CREDIT */}
            <ADSCredit />

            {/* MAIN CONTENT */}
            <ADSContent />
          </div>
        </ImageEditorProvider>
      </ADSProvider>
    </AIToolsProvider>
  );
};

export default ADS;
